import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <div className="h-screen flex justify-center items-center bg-gradient-to-r from-red-300 to-blue-300">
        <p className="text-2xl pb-20 text-white">
          <span className="font-bold">404</span>: Page Not Found
        </p>
      </div>
      <div
        className="absolute bottom-0 py-8 flex justify-center w-full text-xl font-semibold text-white "
        style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
      >
        <button
          onClick={() => {
            navigate("/login");
          }}
        >
          flashcards
        </button>
      </div>
    </>
  );
}

export default NotFound;
